// extracted by mini-css-extract-plugin
export default {"tax-item":"_5FOZ4","taxItem":"_5FOZ4","ellipsis":"ySvlX"};